/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/routes/base';


export default class extends Base
{
  isRouteVisible ()
  {
    return this.isZoneLocation() && this.isUserOwner() && this.isZoneCenterAndBuildingExists() && this.isBuildingLauncher();
  }


  isRouteDisabled ()
  {
    return !this.isBuildingStatusDefault() && !this.isBuildingStatusSetupOrActive();
  }


  isRouteActivated ()
  {
    return this.isBuildingStatusSetupOrActive();
  }


  isZoneCenterAndBuildingExists ()
  {
    const currentZone = this.currentLocation.getZone();

    return currentZone.getCass().isCenter() && currentZone.getBuilding() != null;
  }


  isBuildingLauncher ()
  {
    const building = this.currentLocation.getZone().getBuilding();

    return building && building.canFireProjectiles();
  }


  isBuildingStatusSetupOrActive ()
  {
    const building = this.currentLocation.getZone().getBuilding();

    return building && (building.getStatus().isSetup() || building.getStatus().isActive());
  }


  isBuildingStatusDefault ()
  {
    const building = this.currentLocation.getZone().getBuilding();

    return building && building.getStatus().isDefault();
  }


};
